'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useAppDispatch } from '@/store/hooks';
import { fetchNotifications } from '../store';

// A caixa da equipe interna não tem SSE: o stream do core é por usuário × escritório, e os avisos
// da secretaria ficam espalhados por N escritórios. O painel relê a caixa neste intervalo.
const POLL_INTERVAL_MS = 60 * 1000;

/**
 * Mantém o sino do painel da secretaria atualizado (`/admin/sino`). Monte uma vez só, no layout
 * do painel: os sinos com `fonte="equipeInterna"` não buscam sozinhos, e cada montagem deste hook
 * é um polling a mais. Com a aba oculta não relê; ao voltar a ficar visível, relê na hora.
 *
 * @example useNotificacoesEquipeInternaPolling(); // em AdminLayoutInner
 */
export function useNotificacoesEquipeInternaPolling() {
  const $ = _c(3);
  const dispatch = useAppDispatch();
  let t0;
  let t1;
  if ($[0] !== dispatch) {
    t0 = () => {
      const relerCaixa = () => {
        if (document.visibilityState === "hidden") {
          return;
        }
        dispatch(fetchNotifications("equipeInterna"));
      };
      relerCaixa();
      const intervalId = setInterval(relerCaixa, POLL_INTERVAL_MS);
      document.addEventListener("visibilitychange", relerCaixa);
      return () => {
        clearInterval(intervalId);
        document.removeEventListener("visibilitychange", relerCaixa);
      };
    };
    t1 = [dispatch];
    $[0] = dispatch;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}